import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./SocialL3.module.css";

function SocialL3({ distrito }) {
  const [empreendedorismo, setEmpreendedorismo] = useState(null);
  const [recebeRecursos, setRecebeRecursos] = useState(null);
  const [atividadeRural, setAtividadeRural] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [empreendedorismo, recebeRecursos, atividadeRural] =
          await Promise.all([
            Api.getEmpreendedorismo(distrito),
            Api.getRecebeRecursos(distrito),
            Api.getAtividadePrincipal(distrito),
          ]);
        setEmpreendedorismo(
          Functions.buildSmallPieGraphParams(empreendedorismo)
        );
        setRecebeRecursos(Functions.buildSmallPieGraphParams(recebeRecursos));
        setAtividadeRural(Functions.buildSmallPieGraphParams(atividadeRural));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);
  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.socialL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {empreendedorismo && (
            <SmallPieGraph
              data={empreendedorismo}
              text="TÊM INTERESSE EM EMPREENDEDORISMO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {recebeRecursos && (
            <SmallPieGraph
              data={recebeRecursos}
              text="RECEBE RECURSOS"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {atividadeRural && (
            <SmallPieGraph
              data={atividadeRural}
              text="ATIVIDADE PRINCIPAL RURAL"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SocialL3;
